module.exports = __webpack_public_path__ + "img/cb-loading.ed4ab9fd.svg";